/* src/app/workshop/components/driver-report/driver-report.component.scss */
.datePicker {
  display: inline-block;
  position: absolute;
  left: 15rem;
  top: 3rem;
}
/*# sourceMappingURL=driver-report.component.css.map */
